<af-main-container #mainContainer
                   [title]="entryId
                       ? ('i18n_af_labelEditMsisdnFraudEntry' | translate)
                       : ('i18n_af_labelCreateMsisdnFraudEntry' | translate)"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [filterNavigationPath]="Path.MSISDN_FRAUD_ENTRIES"
                   [specialFilter]="filter"
                   [customNavigateToPath]="customNavigateToPath"
                   [queryParamsHandling]="'merge'"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">
    <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <ui-kit-button type="secondary"
                       spinnerId="saveEdit"
                       [label]="'i18n_af_buttonCancel' | translate"
                       (clickListener)="mainContainer.breadcrumbs.navigateBack()"/>
        <ui-kit-button spinnerId="saveEdit"
                       [label]="'i18n_af_buttonSave' | translate"
                       (clickListener)="save()"/>
    </div>
    @if (isFormReady) {
        <div class="w-100 mt-24 pt-24 pr-24 pb-24 pl-24 bc-primary-white radius-16 overflow-y-scroll">
            <af-msisdn-fraud-form [form]="form" [lockedControls]="lockedControls"/>
        </div>
    }
</af-main-container>
